module.exports = __webpack_public_path__ + "img/snackbar-success.2c41dbf9.svg";